import React from 'react';
import { useHistory } from 'react-router';



import {
 FooterContainerFluid,
 FooterCopyright,
 Container,CollectionList,CollectionListItem
} from './FooterWidgetComponent.style';


export default function FooterWidgetComponent() {
const history = useHistory();
const toPocket=()=> history.push('/pocket')
const toBlog=()=> history.push('/blog')
const toAbout=()=> history.push('/about')
const toSavingsPlan=()=> history.push('/savings-plan')
const toTerms=()=> history.push('/terms')
const toFaqs=()=> history.push('/faqs')
const toPrivacy=()=> history.push('/privacy')

  return (
    <div>
      <FooterContainerFluid className=' white'>
        <Container>
          <div className='row'>
            <div className='col s12 m12 l3'>
              <CollectionList>
                <CollectionListItem class="collection-header">
                  <span><b>Product</b></span>
                  </CollectionListItem>
                <CollectionListItem class="collection-item " onClick={toSavingsPlan}>
                  Saving Plans
                </CollectionListItem>
                {/* <CollectionListItem class="collection-item " onClick={toPocket}>
                  Purse
                </CollectionListItem> */}
              </CollectionList>
            </div>
            <div className='col s12 m12 l3'>
              <CollectionList>
                <CollectionListItem class="collection-header">
                  <span><b>Company</b></span>
                  </CollectionListItem>
                <CollectionListItem class="collection-item " onClick={toAbout}>
                  About 
                </CollectionListItem>
                <CollectionListItem class="collection-item " onClick={toBlog}>
                  Blog 
                </CollectionListItem>
                <CollectionListItem class="collection-item"  onClick={toFaqs}>
                  FAQs
                </CollectionListItem>
                <CollectionListItem class="collection-item " onClick={toTerms}>
                  Terms
                </CollectionListItem>
                <CollectionListItem class="collection-item " onClick={toPrivacy}>
                  Privacy
                </CollectionListItem>
              </CollectionList>

            </div>
            <div className='col s12 m12 l3'>
              <CollectionList>
                <CollectionListItem class="collection-header">
                  <span><b> Contact</b></span>
                  </CollectionListItem>
                <CollectionListItem class="collection-item ">
                  <div style={{
                    width:"215px",
                    display:"flex",
                    marginLeft:"-10px",
                    justifyContent:"space-around"
                  }}>
                    <a href="https://www.facebook.com/yallanigeria/" target="_blank">
                      <img src={"https://res.cloudinary.com/yalla-ng/image/upload/v1662061362/socials/facebook.ec3173b0_hwjeox.svg"} width="30px"  alt=""/> 
                    </a>
                    <a href="https://www.instagram.com/yallanigeria/" target="_blank">
                      <img src={"https://res.cloudinary.com/yalla-ng/image/upload/v1662061360/socials/instagram.d7e77292_vqhj1l.svg"} width="30px" alt=""/>    
                    </a>
                    <a href="https://twitter.com/Yallanigeria" target="_blank">
                      <img src={"https://res.cloudinary.com/yalla-ng/image/upload/v1662061354/socials/twitter.6bd06c53_fwyivw.svg"} width="30px" alt=""/>    
                    </a>
                    <a href="https://ng.linkedin.com/company/yallanigeria" target="_blank">
                      <img src={"https://res.cloudinary.com/yalla-ng/image/upload/v1662061352/socials/linkedin.8538b9cc_wzx4ug.svg"} width="26px" alt=""/>
                    </a>
                  </div>
                     
                </CollectionListItem>
                <CollectionListItem class="collection-item ">
                  +2348183781220    
                </CollectionListItem>
                <CollectionListItem class="collection-item ">
                  hello@yalla.ng
                </CollectionListItem>
                
              </CollectionList>
            </div>
            <div className='col s12 m12 l3'></div>
          </div>
          
        </Container>
        <FooterCopyright>
          <Container>
            <div className=''>
              <br/><br/><br/><br/><br/>
              <br/><br/><br/><br/><br/>
              <div className='row'>
                <div className='col s12 '>
                  <p>© Yalla Nigeria, 2022</p>
                </div>
              </div>
            </div>
          </Container>
        </FooterCopyright>
      </FooterContainerFluid>
    </div>
  )
}
